import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { EXECUTION_STEPS } from '../constants';

interface ExecutionProgressProps {
  currentStep: number;
  stepLabel: string;
}

export function ExecutionProgress({
  currentStep,
  stepLabel,
}: ExecutionProgressProps) {
  const { t } = useTranslation('customer-onboarding');
  const totalSteps = EXECUTION_STEPS.length;
  const progressPercent = Math.round(((currentStep + 1) / totalSteps) * 100);

  const getStepLabel = (step: string) => t(`execution.steps.${step}`);

  return (
    <div className="rounded-lg border bg-card p-6">
      <div className="mb-4 flex items-center gap-3">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <h3 className="font-semibold">{t('execution.title')}</h3>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            {t('execution.processing', { step: getStepLabel(stepLabel || EXECUTION_STEPS[currentStep]) })}
          </span>
          <span className="font-medium">{progressPercent}%</span>
        </div>

        <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
          <div
            className="h-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${progressPercent}%` }}
          />
        </div>

        <div className="flex justify-between text-xs text-muted-foreground">
          <span>
            {t('execution.stepOf', { current: currentStep + 1, total: totalSteps })}
          </span>
          <span>
            {EXECUTION_STEPS.slice(0, currentStep + 1)
              .map((s) => getStepLabel(s))
              .join(' → ')}
          </span>
        </div>
      </div>
    </div>
  );
}
